import './App.css';
import './base/base-i18n/config';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { RoutePaths } from './routes/RoutePaths';
import {
    LoginPage,
    DashboardPage,
    ForgotPasswordPage,
    ChangePasswordPage,
    ResetPasswordPage,
    JobsPage,
    OpenPositionsPage,
    PositionPage,
    ToolsCreateJobPage,
    SavedForLaterPage,
    ToolsCompanyDetailsPage,
    SettingsPage,
    EmailTemplatesPage,
    UserSettingsPage,
    ToolsViewAnswersHistoryPage,
    TermsAndServicesPage,
    PrivacyPolicyPage,
    ReportsPage,
    ScheduleInterviewPage,
} from './pages';
import AuthLayout from './routes/AuthLayout';
import NonAuthLayout from './routes/NonAuthLayout';
import CandidatesLayout from './routes/CandidatesLayout';
import JobApplicationsPage from './pages/JobApplicationsPage';
import { useEffect } from 'react';
import { useAppDispatch } from './base';
import { tablesActions } from './actions';
import ToolsLayout from './routes/ToolsLayout';

function App() {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const path = location.pathname;

    useEffect(() => {
        dispatch(tablesActions.handlePathChanged({ path }));
    }, [dispatch, path]);

    return (
        <Routes>
            <Route
                path={RoutePaths.root}
                element={<Navigate to={RoutePaths.dashboard} />}
            />
            <Route element={<CandidatesLayout />}>
                <Route
                    path={RoutePaths.positions}
                    element={<OpenPositionsPage />}
                />
                <Route
                    path={`${RoutePaths.positions}/:id`}
                    element={<PositionPage />}
                />
            </Route>
            <Route element={<AuthLayout />}>
                <Route
                    path={RoutePaths.changePassword}
                    element={<ChangePasswordPage />}
                />
                <Route
                    path={RoutePaths.dashboard}
                    element={<DashboardPage />}
                />
                <Route path={RoutePaths.jobs} element={<JobsPage />} />
                <Route
                    path={`${RoutePaths.jobs}${RoutePaths.saveJob}`}
                    element={<JobsPage />}
                />
                <Route path={`${RoutePaths.jobs}/:id`} element={<JobsPage />} />
                <Route
                    path={`${RoutePaths.jobs}/:id${RoutePaths.saveJob}`}
                    element={<JobsPage />}
                />
                <Route
                    path={RoutePaths.jobApplications}
                    element={<JobApplicationsPage />}
                />
                <Route
                    path={`${RoutePaths.jobApplications}/:id`}
                    element={<JobApplicationsPage />}
                />
                <Route
                    path={RoutePaths.savedForLater}
                    element={<SavedForLaterPage />}
                />
                <Route path={RoutePaths.settings} element={<SettingsPage />} />
                <Route
                    path={RoutePaths.emailTemplates}
                    element={<EmailTemplatesPage />}
                />
                <Route
                    path={RoutePaths.userSettings}
                    element={<UserSettingsPage />}
                />
                <Route path={RoutePaths.reports} element={<ReportsPage />} />
            </Route>
            <Route element={<NonAuthLayout />}>
                <Route path={RoutePaths.login} element={<LoginPage />} />
                <Route
                    path={RoutePaths.forgotPassword}
                    element={<ForgotPasswordPage />}
                />
                <Route
                    path={RoutePaths.resetPassword}
                    element={<ResetPasswordPage />}
                />
            </Route>
            <Route element={<ToolsLayout />}>
                <Route
                    path={RoutePaths.chat}
                    element={<ToolsCreateJobPage />}
                />
                <Route
                    path={RoutePaths.companyDetails}
                    element={<ToolsCompanyDetailsPage />}
                />
                <Route
                    path={RoutePaths.viewAnswerHistory}
                    element={<ToolsViewAnswersHistoryPage />}
                />
            </Route>
            {/* Public pages without any layout */}
            <Route
                path={RoutePaths.termsAndServices}
                element={<TermsAndServicesPage />}
            />
            <Route
                path={RoutePaths.privacyPolicy}
                element={<PrivacyPolicyPage />}
            />
            <Route
                path={RoutePaths.scheduleInterview}
                element={<ScheduleInterviewPage />}
            />
        </Routes>
    );
}

export default App;
